import { render, staticRenderFns } from "./OrderModal.vue?vue&type=template&id=b7ecce98"
import script from "./OrderModal.vue?vue&type=script&lang=js"
export * from "./OrderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports